export const openArrowNav = () => ({
	type: 'OPEN_ARROW_NAV',
})

export const closeArrowNav = () => ({
	type: 'CLOSE_ARROW_NAV',
})
